import React, { useRef } from 'react'
import {
    Box,
    Card,
    CardContent,
    Container,
    Grid,
    IconButton,
    Typography,
} from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import styled from 'styled-components'
import LoveEarth from '../../assets/gif/LoveEarth.gif'
import ExpandGallery from '../../components/gallery/ExpandGallery'
import setKey from '../../hooks/setKey'

import FirManI1 from '../../assets/img/career-gd6019cac5_1280.jpg'
import FirManI2 from '../../assets/img/rescue-g8c01b5b97_1280.jpg'
import FirManI3 from '../../assets/img/fire-gffcacbf7c_1280.jpg'
import FirManI4 from '../../assets/img/vehicle-g4cbd79310_1280.jpg'
import FirManI5 from '../../assets/img/fire-g6d1eac978_1280.jpg'
import FirManI7 from '../../assets/img/turnbuckle-g5cd1b80e3_1280.jpg'
import FirManI12 from '../../assets/img/machine-gea8e3ff50_1280.jpg'
import FirManI13 from '../../assets/img/pressurized-water-pipe-g442733aa4_1280.jpg'
import FirManI14 from '../../assets/img/signal-g12270fee8_1280.jpg'
import FirManI15 from '../../assets/img/slippery-gcb6acb070_1280.jpg'
import FirManI16 from '../../assets/img/volunteering-g16943517e_1280.jpg'
import FirManI17 from '../../assets/img/fire-engine-gebdbfac74_1280.jpg'
import FirManI18 from '../../assets/img/firefighter-g60ac6187d_1280.jpg'
import FirManI19 from '../../assets/img/fire-fighters-g7eb8391cc_1280.jpg'

import p1 from '../../assets/img/Productos/p1.png'
import p2 from '../../assets/img/Productos/p2.png'
import p3 from '../../assets/img/Productos/p3.png'
import p4 from '../../assets/img/Productos/p4.png'
import p5 from '../../assets/img/Productos/p5.png'
import p6 from '../../assets/img/Productos/p6.png'
import p7 from '../../assets/img/Productos/p7.png'
import p8 from '../../assets/img/Productos/p8.png'
import p9 from '../../assets/img/Productos/p9.png'
import p10 from '../../assets/img/Productos/p10.png'
import p11 from '../../assets/img/Productos/p11.png'

const ProductCarousel = ({ images = [] }) => {
    const scrollRef = useRef(null)

    const handleScroll = (direction) => {
        if (!scrollRef.current) return
        const amount = 320
        scrollRef.current.scrollBy({
            left: direction === 'left' ? -amount : amount,
            behavior: 'smooth',
        })
    }

    return (
        <Box sx={{ position: 'relative', width: '100%', px: { xs: 2, md: 6 } }}>
            <IconButton
                onClick={() => handleScroll('left')}
                sx={{
                    position: 'absolute',
                    left: { xs: 0, md: 10 },
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 3,
                    bgcolor: 'rgba(255,255,255,.95)',
                    boxShadow: 2,
                    '&:hover': { bgcolor: '#fff' },
                }}
            >
                <ChevronLeftIcon />
            </IconButton>

            <Box
                ref={scrollRef}
                sx={{
                    display: 'flex',
                    gap: 3,
                    overflowX: 'auto',
                    scrollBehavior: 'smooth',
                    scrollSnapType: 'x mandatory',
                    py: 2,
                    px: { xs: 4, md: 6 },
                    '&::-webkit-scrollbar': {
                        height: 5,
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f1f1f1',
                        borderRadius: 999,
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#c1c1c1',
                        borderRadius: 999,
                    },
                }}
            >
                {images.map((item) => (
                    <Box
                        key={item.id}
                        sx={{
                            flex: '0 0 auto',
                            width: { xs: 220, sm: 260, md: 280 },
                            scrollSnapAlign: 'start',
                        }}
                    >
                        <Card
                            sx={{
                                width: '100%',
                                height: { xs: 260, sm: 300, md: 340 },
                                borderRadius: 3,
                                overflow: 'hidden',
                                backgroundColor: '#fff',
                                boxShadow: '0px 10px 25px rgba(0,0,0,0.12)',
                                transition: 'transform .35s ease, box-shadow .35s ease',
                                '&:hover': {
                                    transform: 'scale(1.06)',
                                    boxShadow: '0px 18px 35px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#fff',
                                    p: 2,
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.image}
                                    alt={`producto-${item.id}`}
                                    sx={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        objectFit: 'contain',
                                    }}
                                />
                            </Box>
                        </Card>
                    </Box>
                ))}
            </Box>

            <IconButton
                onClick={() => handleScroll('right')}
                sx={{
                    position: 'absolute',
                    right: { xs: 0, md: 10 },
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 3,
                    bgcolor: 'rgba(255,255,255,.95)',
                    boxShadow: 2,
                    '&:hover': { bgcolor: '#fff' },
                }}
            >
                <ChevronRightIcon />
            </IconButton>
        </Box>
    )
}

const Services = () => {
    const FiremanCourseImage = [
        { id: setKey(), image: FirManI1 },
        { id: setKey(), image: FirManI2 },
        { id: setKey(), image: FirManI3 },
        { id: setKey(), image: FirManI4 },
        { id: setKey(), image: FirManI5 },
    ]

    const FiremanEquipImage = [
        { id: setKey(), image: p1 },
        { id: setKey(), image: p2 },
        { id: setKey(), image: p3 },
        { id: setKey(), image: p4 },
        { id: setKey(), image: p5 },
        { id: setKey(), image: p6 },
        { id: setKey(), image: p7 },
        { id: setKey(), image: p8 },
        { id: setKey(), image: p9 },
        { id: setKey(), image: p10 },
        { id: setKey(), image: p11 },
    ]

    const FiremanMaintenanceImage = [
        { id: setKey(), image: FirManI12 },
        { id: setKey(), image: FirManI13 },
    ]

    const FiremanSignalsImage = [
        { id: setKey(), image: FirManI7 },
        { id: setKey(), image: FirManI14 },
        { id: setKey(), image: FirManI15 },
    ]

    const FiremanTrainingImage = [
        { id: setKey(), image: FirManI16 },
        { id: setKey(), image: FirManI17 },
        { id: setKey(), image: FirManI18 },
        { id: setKey(), image: FirManI19 },
    ]

    return (
        <Container maxWidth="xl">
            <Box padding="40px 0px">
                <Typography variant="h2" component="h1" textAlign="center">
                    Nuestros Servicios
                </Typography>

                <Grid container spacing={2} marginBottom={6}>
                    <Grid item xs={12}>
                        <Typography
                            className="animate__animated animate__fadeIn"
                            textAlign="justify"
                        >
                            Tener equipos y elementos para la protección y prevención de
                            desastres e incendios es fundamental para garantizar la
                            seguridad de las personas y proteger sus bienes. Estos
                            elementos incluyen equipos de extinción de incendios,
                            detectores de humo, alarmas, equipos de evacuación y rescate,
                            entre otros. Su importancia radica en que nos permiten actuar
                            de manera rápida y efectiva ante una emergencia, minimizando
                            los daños y evitando situaciones aún más catastróficas.
                            Además, contar con estos elementos y equipos adecuados también
                            puede reducir el riesgo de incendios y otros desastres, ya
                            que nos permite detectar y prevenir situaciones de riesgo
                            antes de que se conviertan en una emergencia. En resumen, la
                            importancia de tener equipos y elementos para la protección y
                            prevención de desastres e incendios radica en que nos
                            permiten actuar de manera preventiva y efectiva, reducir los
                            daños y garantizar la seguridad de las personas.
                        </Typography>
                    </Grid>
                </Grid>

                <GifDoc src={LoveEarth} alt="Servicios Sociales" />

                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ boxShadow: '0px 0px 15px -6px #333' }}>
                            <CardContent>
                                <Typography variant="h3" textAlign="center">
                                    Cursos para Bomberos
                                </Typography>
                                <Typography marginBottom={4}>
                                    Para nosotros es importante saber que nuestros
                                    Bomberos tienen la mejor capacitación, es por ello
                                    que nosotros contamos con varios cursos que mejoraran
                                    las habilidades y capacidades de los bomberos que nos
                                    brindan sus servicios.
                                </Typography>

                                <ExpandGallery Images={FiremanCourseImage} />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ boxShadow: '0px 0px 15px -6px #333' }}>
                            <CardContent>
                                <Typography variant="h3" textAlign="center">
                                    Equipos contra incendio y su mantenimiento
                                </Typography>
                                <Typography marginBottom={4}>
                                    Colombia es uno de los países con la mejor
                                    reglamentación de sismo resistencia para
                                    construcciones de la región. En ella destacan muchas
                                    medidas que se toman en el primer mundo, una, es la
                                    obligatoriedad de la implementación de sistemas contra
                                    incendios.
                                </Typography>

                                <ProductCarousel images={FiremanEquipImage} />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ boxShadow: '0px 0px 15px -6px #333' }}>
                            <CardContent>
                                <Typography variant="h3" textAlign="center">
                                    Mantenimiento de redes hidráulicas
                                </Typography>
                                <Typography marginBottom={4}>
                                    El mantenimiento de las Redes Hidráulicas se debe
                                    hacer con frecuencia para de este modo evitar daños en
                                    las mismas, es por ello que aquí en Fenabocol ORG te
                                    brindamos este servicio.
                                </Typography>

                                <ExpandGallery Images={FiremanMaintenanceImage} />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ boxShadow: '0px 0px 15px -6px #333' }}>
                            <CardContent>
                                <Typography variant="h3" textAlign="center">
                                    Señalización
                                </Typography>
                                <Typography marginBottom={4}>
                                    Actualmente existen en Colombia leyes y resoluciones
                                    relacionadas con las normas en señalización, que
                                    buscan asegurar la integridad y salud del ser humano
                                    en el ámbito laboral y en lugares públicos, para ello
                                    Fenabocol ORG te ayuda a realizar la debida
                                    señalización.
                                </Typography>

                                <ExpandGallery Images={FiremanSignalsImage} />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12}>
                        <Card variant="outlined" sx={{ boxShadow: '0px 0px 15px -6px #333' }}>
                            <CardContent>
                                <Typography variant="h3" textAlign="center">
                                    Capacitación para brigadas
                                </Typography>
                                <Typography marginBottom={4}>
                                    Aquí en Fenabocol ORG nos comprometemos con nuestros
                                    brigadistas, es por ello que capacitamos a nuestro
                                    personal, así como brindamos el servicio para
                                    capacitar a otras personas que quieran ser
                                    brigadistas.
                                </Typography>

                                <ExpandGallery Images={FiremanTrainingImage} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    )
}

export default Services

const GifDoc = styled.img`
  width: 100%;
  max-width: 600px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.3;
  z-index: -1;
`